import * as Yup from "yup";

// Register Validation
export const addAgentValidation = Yup.object().shape({
  phone: Yup.string("").required("Please enter phone."),
  email: Yup.string().email("Invalid email Id").required("Email is required"),
});

export const profileAgentValidation = () => {
  return Yup.object().shape({
    // Personal Details
    firstName: Yup.string("").required("First name is required."),
    middleName: Yup.string("").required("Middle name is required."),
    lastName: Yup.string("").required("Last name is required."),
    pan: Yup.string()
      .matches(/^([A-Za-z]){3}[pP]([A-Za-z]){1}([0-9]){4}([A-Za-z]){1}$/, "Enter valid PAN.")
      .required("PAN is required"),
    city: Yup.string("").required("City is required."),
    state: Yup.string("").required("State is required."),
    pincode: Yup.string("").required("Pincode is required."),
    address: Yup.string("").required("Address is required."),

    // Bank Details
    bankAccountNumber: Yup.string("").required("Bank account number is required."),
    accountHolderName: Yup.string("").required("Account holder name is required."),
    bankIFSC: Yup.string("")
      .matches(/^[A-Za-z]{4}\d{7}$/, "Enter valid IFSC code.")
      .required("IFSC is required."),
    bankName: Yup.string("").required("Bank name is required."),
    verificationDocumentType: Yup.string("").required("Document type is required."),
  });
};
